const listAutoridadesElectorales = [
    {
        "idEntidad": 10,
        "nombreEntidad": "DURANGO",
        "numPartidosLocales": 0,
        "numPartidosLocalesText": "A nivel nacional hay seis partidos políticos registrados; mientras que, a nivel local, en Durango hay tres partidos políticos locales registrados ante el IEPC.",
        "autoridadesElectorales": "el Instituto Electoral y de Participación Ciudadana del Estado de Durango (IEPC)",
        "autoridadesElectoralesL2": "el Instituto Electoral y de Participación Ciudadana del Estado de Durango (IEPC), el Tribunal Electoral del Estado de Durango y la Unidad Especializada en Delitos Electorales.",
        "autoridadesElectoralesL3": "IEPC de Durango",
        "autoridadesElectoralesL4": "el IEPC",
        "textoIntroduccionL4":"los resultados y declaración de validez de la elección",
        "textoIntroduccionL8":"tres",
        "textoObjetivoL81":"a través de la Urna Electrónica (UE), Voto Anticipado (VA) y Voto de Personas en Prisión Preventiva (VPPP).",
        "textoObjetivoL82":"Es importante que sepas que el voto mediante UE, así como el de VA y VPPP dependen de la normatividad local y de la posibilidad de llevarla a cabo.",
        "cargosEleccion": "también se elegirán diputaciones locales.",
        "emisionConvocatoria": "El Consejo General del IEPC emitirá la convocatoria para la elección de ayuntamientos.",
        "participacionT1": "También pueden participar mediante candidaturas comunes.",
        "participacionT2": "El partido político, coalición o candidatura común",
        "participacionT3": "las coaliciones o candidaturas comunes",
        "inicioPE": "con la primera sesión del Consejo General del IEPC el 1 de noviembre de 2024 y concluye con la declaración de validez de la elección, o con las resoluciones que en su caso emita el Tribunal Electoral del Estado de Durango.",
        "integracionOE": "se instalarán 39 consejos municipales que iniciarán sus sesiones a más tardar la primera semana del mes de enero de 2025. Además de un Consejo Local y cuatro Consejos Distritales del INE.",
        "terceraEtapaL4": "Resultados y declaración de validez de la elección.",
        "remisionPaquetes": "Se inicia con la remisión de los paquetes, documentación y expedientes electorales a los consejos municipales del IEPC y concluye con los cómputos y declaraciones de validez de las elecciones por parte de los consejos municipales del IEPC, o con las resoluciones que, en su caso, emita en última instancia el órgano jurisdiccional correspondiente.",
        "prep": "Es el procedimiento mediante el cual los consejos municipales del IEPC, en sesión permanente, consultan los resultados del Acta de Escrutinio y Cómputo conforme se vayan recibiendo los paquetes electorales.",
        "nulidadL6": "en el artículo 53 de la Ley de Medios de Impugnación en Materia Electoral y de Participación Ciudadana para el Estado de Durango.",
        "impugnacionL6": "la Ley de Medios de Impugnación en Materia Electoral y de Participación Ciudadana para el Estado de Durango y se resuelven ante el Tribunal Electoral del Estado de Durango."
    },
    {
        "idEntidad": 30,
        "nombreEntidad": "VERACRUZ",
        "numPartidosLocales": 0,
        "numPartidosLocalesText": "A nivel nacional hay siete partidos políticos registrados; mientras que a nivel local, en Veracruz hay registrado un partido político ante el Organismo Público Local Electoral del Estado de Veracruz.",
        "autoridadesElectorales": "el Organismo Público Local Electoral del Estado de Veracruz (OPLE Veracruz)",
        "autoridadesElectoralesL2": "el OPLE Veracruz, el Tribunal Electoral de Veracruz y la Fiscalía Especializada en Delitos Electorales y en Delitos Contra la Libertad de Expresión.",
        "autoridadesElectoralesL3": "OPLE Veracruz",
        "autoridadesElectoralesL4": "OPLE Veracruz",
        "textoIntroduccionL4":"los actos posteriores a la elección y los resultados electorales",
        "textoIntroduccionL8":"dos",
        "textoObjetivoL81":"a través de la Urna Electrónica (UE) y Voto Anticipado (VA).",
        "textoObjetivoL82":"Es importante que sepas que el voto mediante UE, así como el de VA y VPPP dependen de la normatividad local y de la posibilidad de llevarla a cabo.",
        "cargosEleccion": "también se elegirá una gubernatura y diputaciones locales.",
        "emisionConvocatoria": "El Consejo General del OPLE Veracruz emitirá la convocatoria para la elección de ayuntamientos.",
        "participacionT1": "",
        "participacionT2": "El partido político o coalición",
        "participacionT3": "las coaliciones",
        "inicioPE": "con la sesión de instalación del Consejo General del OPLE Veracruz en los primeros 10 días del mes de noviembre de 2024 y concluye con la emisión de las sentencias definitivas de los órganos jurisdiccionales competentes, respecto de los medios de impugnación.",
        "integracionOE": "se instalarán 212 consejos municipales que iniciarán sus sesiones a más tardar el 28 de febrero de 2025. Además de un Consejo Local y 19 Consejos Distritales del INE.",
        "terceraEtapaL4": "Actos posteriores a la elección y los Resultados electorales.",
        "remisionPaquetes": "Se inicia con la remisión de los paquetes, documentación y expedientes electorales a los consejos municipales del OPLE Veracruz, y concluye con los cómputos y declaraciones de validez de las elecciones por los Consejos Municipales del OPLE Veracruz, o con las resoluciones que, en su caso, emita en última instancia el órgano jurisdiccional correspondiente.",
        "prep": "Es el procedimiento mediante el cual los consejos municipales del OPLE Veracruz, en sesión permanente, consultan los resultados del Acta de Escrutinio y Cómputo conforme se vayan recibiendo los paquetes electorales.",
        "nulidadL6": "en el artículo 395 del Código Electoral del Estado de Veracruz.",
        "impugnacionL6":"los artículos 348, 350, 351, 352 y 401 del Código Electoral del Estado de Veracruz y resuelven ante el Tribunal Electoral de Veracruz y el Consejo General del OPLE Veracruz."
    },
    
]

export function getObjetoAutoridad (idEntidad) {
    const autoridades = listAutoridadesElectorales.find(item => item.idEntidad === idEntidad);
    return  autoridades; 
}

export function getPartidosLocales (idEntidad) {
    const autoridades = listAutoridadesElectorales.find(item => item.idEntidad === idEntidad);
    return  autoridades.numPartidosLocalesText; 
}

export function getAutoridadesEntidad (idEntidad) {
    const autoridades = listAutoridadesElectorales.find(item => item.idEntidad === idEntidad);
    return  autoridades.autoridadesElectorales; 
}

export function getAutoridadesEntidadL2 (idEntidad) {
    const autoridades = listAutoridadesElectorales.find(item => item.idEntidad === idEntidad);
    return  autoridades.autoridadesElectoralesL2; 
}

export function getAutoridadesEntidadL3 (idEntidad) {
    const autoridades = listAutoridadesElectorales.find(item => item.idEntidad === idEntidad);
    return  autoridades.autoridadesElectoralesL3; 
}

export function getCargosEleccion (idEntidad) {
    const autoridades = listAutoridadesElectorales.find(item => item.idEntidad === idEntidad);
    return  autoridades.cargosEleccion; 
}

export function getEmisionConvocatoria (idEntidad) {
    const autoridades = listAutoridadesElectorales.find(item => item.idEntidad === idEntidad);
    return  autoridades.emisionConvocatoria; 
}

export function getInicioEleccion (idEntidad) {
    const autoridades = listAutoridadesElectorales.find(item => item.idEntidad === idEntidad);
    return  autoridades.inicioPE; 
}

export function getIntegracionOE (idEntidad) {
    const autoridades = listAutoridadesElectorales.find(item => item.idEntidad === idEntidad);
    return  autoridades.integracionOE; 
}

export function getRemisionPaquetes (idEntidad) {
    const autoridades = listAutoridadesElectorales.find(item => item.idEntidad === idEntidad);
    return  autoridades.remisionPaquetes; 
}

export function getConsultaPREP (idEntidad) {
    const autoridades = listAutoridadesElectorales.find(item => item.idEntidad === idEntidad);
    return  autoridades.prep; 
}

export function nombreOPL (idEntidad) {
        const autoridades = listAutoridadesElectorales.find(item => item.idEntidad === idEntidad);
        const OPL = autoridades.autoridadesElectorales.split(", "); 
        return  OPL[0];
}